<template>
    <div>
        <el-form class="el_head_search" ref="form" :model="form" label-width="80px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="用户名" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="用户uid" prop="uid">
                        <el-input v-model="form.uid"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" class="btns">
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                    <el-button type="primary" size="small" @click="resetForm">重置</el-button>
                </el-col>
            </el-row>
        </el-form>

        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column prop="name" label="用户名" fixed="left">
                <template slot-scope="scope">
                    {{ scope.row.author_info.name || scope.row.author_info.displayName || scope.row.author_info.email }}
                </template>
            </el-table-column>
            <el-table-column prop="uid" label="uid" width="330">
                <template slot-scope="scope">
                    {{ scope.row.author_info.uid }}
                </template>
            </el-table-column>
            <el-table-column prop="points" label="增加积分数值"></el-table-column>
            <el-table-column prop="created_at" label="时间(UTC)">
                <template slot-scope="scope">
                    {{ $moment(new Date(scope.row.created_at).getTime()).utc().format('YYYY-MM-DD HH:mm:ss') }}
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import serverApi from '../../server/index';
import AddPointsModal from './addPoints';
export default {
    data() {
        return {
            form: {
                name: '',
                uid: '',
            },

            tableData: [],
            params: {
                page: 1,
                size: 10,
            },
            total: 0,
            loading: true,
        };
    },
    components: { AddPointsModal },
    created() {
        this.getManualPointsList();
    },
    methods: {
        async getManualPointsList(_params) {
            try {
                const params = {
                    ...this.params,
                    ..._params,
                };
                this.loading = true;
                const { data } = await serverApi.manualPointsList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },

        handleCurrentChange(val) {
            this.getManualPointsList({ page: val });
        },
        search() {
            this.params = { page: 1, size: 10 };
            this.getManualPointsList(this.form);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.getManualPointsList(this.form);
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}
.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>
